import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle
} from '../ui/alert-dialog';
import { Power, PowerOff, AlertTriangle } from 'lucide-react';

const ACTION_CONTENTS = {
  deactivate: (item) => ({
    title: 'Disattiva Articolo',
    description: `L'articolo "${item.brand} ${item.model}" verrà disattivato ma rimarrà nel database.`,
    buttonText: 'Disattiva',
    buttonClass: 'bg-amber-600 hover:bg-amber-700'
  }),
  activate: (item) => ({
    title: 'Riattiva Articolo',
    description: `L'articolo "${item.brand} ${item.model}" verrà riattivato e sarà nuovamente disponibile.`,
    buttonText: 'Riattiva',
    buttonClass: 'bg-emerald-600 hover:bg-emerald-700'
  }),
  delete: (item) => ({
    title: 'Elimina Articolo Definitivamente',
    description: `ATTENZIONE: L'articolo "${item.brand} ${item.model}" verrà eliminato DEFINITIVAMENTE dal database. Questa azione è irreversibile!`,
    buttonText: 'Elimina Definitivamente',
    buttonClass: 'bg-red-600 hover:bg-red-700'
  })
};

export function CatalogActionDialog({ open, onOpenChange, actionItem, actionType, actionLoading, onConfirm }) {
  const content = (actionType && actionItem) ? ACTION_CONTENTS[actionType]?.(actionItem) || {} : {};

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            {actionType === 'delete' && <AlertTriangle className="h-5 w-5 text-red-600" />}
            {actionType === 'deactivate' && <PowerOff className="h-5 w-5 text-amber-600" />}
            {actionType === 'activate' && <Power className="h-5 w-5 text-emerald-600" />}
            {content.title}
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <span>{content.description}</span>
            <span className="text-xs text-muted-foreground block mt-2">
              Codice: {actionItem?.item_code}
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={actionLoading}>Annulla</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={actionLoading}
            className={content.buttonClass}
            data-testid="confirm-action-btn"
          >
            {actionLoading ? 'Elaborazione...' : content.buttonText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
